import { graphql } from '../../gql';

export default graphql(`
    query LoginUrl($email: String!, $recaptchaToken: String!) {
        loginUrl(email: $email, recaptchaToken: $recaptchaToken) {
            url
        }
    }
`);
